<script>
  import { onDestroy, tick, afterUpdate } from 'svelte';
  import { getGroupStore } from '@stores/group';
  let recObjectsStore = getGroupStore('recObjectsStore');
  let groupStore = getGroupStore('groupStore');
  let bookmarkGroupsStore = getGroupStore('bookmarkGroupsStore');
  let bookmarkSelectedStore = getGroupStore('bookmarkSelectedStore');

  import Fuse from 'fuse.js';

  import { getCurrentUserStore } from '@stores/current_user';
  import Notification from '@utils/notification';
  import Log from '@utils/log';
  import DuplicateAjax from '@ajax/duplicate';
  import GroupAjax from '@ajax/group';
  import SectionAjax from '@ajax/section';

  import Modal from '@components/Modal.svelte';
  import Input from '@components/Input.svelte';
  import Button from '@components/Button.svelte';
  import Alert from '@components/Alert.svelte';

  import CreateAccountModal from '@app-components/modal/CreateAccountModal.svelte';
  import AfterCreateInfo from '@app-components/modal/create_account/AfterCreateInfo.svelte';

  export let recObjectId;

  export let mobile = false;
  export let style = '';
  export let text = 'Duplicate';

  export let showPin = true;
  export let collapsed = true;
  export let hovered = false;
  export let customGroupStore;

  import jQuery from 'jquery';

  const SLOTS = $$props.$$slots || {};

  let currentUser = getCurrentUserStore('default');
  let subUser = currentUser.subscribe((x) => (currentUser = x));

  let recObject = recObjectsStore.find(recObjectId);
  let group = customGroupStore || groupStore;
  let groups = bookmarkGroupsStore;
  let groupModalFadeInDuration = 200;
  let unsubRecObject = recObject.subscribe((x) => (recObject = x));
  let unsubGroups = bookmarkGroupsStore.subscribe((x) => (groups = x));

  let showCreateAccountModal = false;
  let showGroupsModal = false;
  let showSectionsModal = false;
  let showAddNewListModal = false;
  let showAddNewSection = false;
  let showCancelDialogForSectionClose = false;
  let showInfoStepsModal = false;

  let groupInputEl;
  let newSectionEl;
  let groupSearchEl;
  let searched = false;

  let selectedGroup;
  let selectedSection;
  let selectedRec;

  let creatingGroup = false;
  let loadingGroups = false;

  $: ownerIds = group && group.users && group.users.filter((u) => u.role === 'admin').map((x) => x.id);

  let bindWindowEvents = function () {
    window.moveBookmark = function () {
      if (selectedSection) {
        displaySectionsModal();
      } else {
        displayGroupsModal(false);
      }
    };

    window.undoBookmark = function () {
      DuplicateAjax.undo(selectedGroup, selectedRec)
        .then(() => {
          Notification.send({
            text: 'Saved recommendation has been removed',
            layout: mobile ? 'topCenter' : 'bottomLeft',
          });

          selectedGroup = undefined;
          selectedSection = undefined;
          selectedRec = undefined;

          bookmarkSelectedStore.set({ group: undefined, section: undefined });
        })
        .catch((err) => {
          if (err) {
            Notification.send({
              text: err.error,
              type: 'error',
            });
          }
        });
    };
  };

  let displayGroupsModal = function () {
    showInfoStepsModal = false;

    selectedGroup = undefined;
    selectedSection = undefined;
    groups = bookmarkGroupsStore;
    searched = false;

    fetchGroups();
    showGroupsModal = true;
  };

  let hideGroupsModal = function () {
    showGroupsModal = false;
  };

  let displaySectionsModal = function () {
    fetchGroups();
    showSectionsModal = true;
  };

  let hideSectionsModal = function (showDialog = false) {
    if (showDialog && !selectedSection) {
      showCancelDialogForSectionClose = true;
      return;
    }

    showSectionsModal = false;
  };

  let displayCreateAccountModal = function () {
    showCreateAccountModal = true;
  };

  let displayAddNewListModal = function () {
    showAddNewListModal = true;
  };

  let hideAddNewListModal = function () {
    showAddNewListModal = false;
  };

  let displayAddNewSection = function () {
    showAddNewSection = true;
  };

  let hideAddNewSection = function () {
    showAddNewSection = false;
  };

  export const saveItButtonClicked = function () {
    if (currentUser && currentUser.id) {
      selectedRec = undefined;

      if (bookmarkSelectedStore && bookmarkSelectedStore.group) {
        selectedGroup = bookmarkSelectedStore.group;
        selectedSection = bookmarkSelectedStore.section;
        saveBookmark();
      } else {
        displayGroupsModal();
      }
    } else {
      displayCreateAccountModal();
    }
  };

  let searchGroups = function () {
    if (groupSearchEl.value === '') {
      groups = bookmarkGroupsStore;
      searched = false;
      return;
    }

    let fuse = new Fuse(groups, {
      keys: ['name'],
      threshold: 0.25,
    });

    groups = fuse.search(groupSearchEl.value).map((x) => x.item);
    searched = true;
  };

  let fetchGroups = async function () {
    loadingGroups = groups && groups.count() === 0;

    try {
      let resp = await DuplicateAjax.fetch(group);

      if (resp && resp.groups && resp.groups.length > 0) {
        bookmarkGroupsStore.set(resp.groups);
      }
    } catch {}

    loadingGroups = false;
  };

  let displaySavingNotification = function () {
    let instance = Notification.send({
      text: '<i class="fa fa-spin fa-spinner"></i><span style="margin-left: 16px">Saving</span>',
      layout: mobile ? 'topCenter' : 'bottomLeft',
      timeout: 0,
    });

    return instance;
  };

  let displayNotification = async function (instance, text) {
    let timeout = 3500;

    if (selectedGroup) {
      text = text.replace(
        '[group]',
        `<a class="hover-underlined bolded" href="${selectedGroup.path}">${selectedGroup.name}</a>`
      );
    }

    if (selectedSection) {
      text = text.replace('[section]', `<span class="bolded">${selectedSection.name}</span>`);
    }

    setTimeout(() => bindWindowEvents(), 0);

    instance.setText(
      `<div class="bookmark-saved-notification"><img class='bookmark-saved-checkmark' src='/images/save-button/check.png' /><div class='main-text'>${text}</div><div class='actions'><span onclick='moveBookmark()'>Change</span><span onclick='undoBookmark()'>Undo</span></div></div>`
    );
    instance.setTimeout(timeout);
  };

  let saveBookmark = async function () {
    let data = {
      rec_object_id: recObject.id,
    };

    if (selectedGroup) {
      data['new_group_id'] = selectedGroup.id;
    }

    if (selectedSection) {
      data['new_section_id'] = selectedSection.id;
    }

    let instance = displaySavingNotification();

    try {
      let resp;

      if (selectedRec) {
        resp = await DuplicateAjax.update(selectedGroup, selectedRec, selectedSection, data);
      } else {
        resp = await DuplicateAjax.create(group, data);
      }

      selectedRec = resp.rec;

      hideGroupsModal();
      hideSectionsModal();

      bookmarkSelectedStore.set({
        group: selectedGroup,
        section: selectedSection,
      });

      displayNotification(instance, selectedSection ? 'Added to [section] in [group]' : 'Added to [group]');
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        instance.setText(err.full_errors[0]);
        instance.setType('error');
        instance.setTimeout(3500);
      } else {
        instance.close();
      }
    }
  };

  let logUserCreatedThroughSaveButton = function (user) {
    try {
      Log.info(
        `New Signup - via Save Button | ${user.name} (${user.email}) | group: ${
          group && group.name
        } (https://benable.com${group && group.path}) | rec object: ${recObject.name1} (${recObject.id})`
      );
    } catch {}
  };

  let createNewSection = async function () {
    if (!newSectionEl || newSectionEl.value === '') {
      hideAddNewSection();
      return;
    }

    try {
      let resp = await SectionAjax.create(selectedGroup, {
        name: newSectionEl.value,
      });

      selectedGroup.sections.push({
        id: resp.id,
        name: resp.name,
        total: 0,
      });

      selectedGroup.sections = selectedGroup.sections;
      hideAddNewSection();

      await tick();

      let el = jQuery('.save-modal-lists:visible');
      if (el.length > 0) {
        el.scrollTop(el[0].scrollHeight);
      }
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
      }
    }
  };

  let createNewList = async function () {
    creatingGroup = true;

    try {
      selectedGroup = await GroupAjax.create({
        name: groupInputEl.value,
        add_to_front: true,
        auto_set_emoji: true,
      });

      hideAddNewListModal();
      saveBookmark();
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
      }
    }

    creatingGroup = false;
  };

  let selectGroup = function (group) {
    selectedGroup = group;
    groups = bookmarkGroupsStore;
    hideGroupsModal();

    if (selectedGroup && selectedGroup.sections.length > 0) {
      displaySectionsModal();
    } else {
      saveBookmark();
    }
  };

  let unselectGroup = function () {
    hideSectionsModal();
    displayGroupsModal();
  };

  let selectSection = function (section) {
    selectedSection = section;
    hideSectionsModal();
    saveBookmark();
  };

  onDestroy(() => {
    subUser();
    unsubRecObject();
    unsubGroups();
  });

  afterUpdate(() => {
    groupModalFadeInDuration = 200;
  });
</script>

<style style="text/scss" lang="scss">
  .ui-save-it-hovered {
    border-color: #ff5567 !important;
    background-color: #ff5567 !important;
    cursor: pointer !important;
    color: white !important;

    svg {
      fill: white !important;
      stroke: white !important;

      path {
        fill: white !important;
        stroke: white !important;
      }
    }

    &:hover {
      background-color: #cc4452 !important;
      border-color: #cc4452 !important;
    }
  }

  .ui-save-it-collapsed {
    width: 40px !important;
  }

  .ui-save-it {
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    border: 2px solid #f8f8f8;
    border-radius: 9px;
    background: transparent;
    margin-bottom: 0px;
    height: 40px;
    justify-content: center;
    align-items: center;
    width: 112px;
  }

  .save-modal {
    margin-top: -30px;
    padding-left: 16px;
    padding-right: 16px;

    .save-modal-header {
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      text-align: center;
    }

    .save-modal-subheader {
      font-size: 14px;
      line-height: 20px;
      opacity: 0.5;
      color: black;
      margin-top: 14px;
      text-align: center;
    }

    .search-search-bar {
      margin-top: 24px;
      position: relative;
    }

    .save-modal-lists-scrolled {
      padding-right: 30px !important;
    }

    .save-modal-lists {
      margin-top: 24px;
      max-height: 312px;
      overflow: auto;
      overflow-x: hidden;
      margin-left: -45px;
      margin-right: -45px;
      padding-left: 45px;
      padding-right: 45px;

      .save-modal-lists-label {
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: #7f7f7f;
        margin-bottom: 12px;
      }
    }

    .add-new-section-container {
      margin-top: 14px;
      position: relative;
      margin-bottom: -28px;

      img {
        position: absolute;
        right: 15px;
        top: 15px;
        cursor: pointer;
      }
    }

    .save-modal-item {
      border-radius: 12px;
      display: flex;
      height: 48px;
      align-items: center;
      padding-left: 20px;
      padding-right: 20px;
      cursor: pointer;
      margin-bottom: 8px;
      transition: 0.1s all;
      box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.08);

      &:hover {
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
      }

      .save-modal-item-name {
        margin-left: 16px;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        display: block;
        overflow: hidden;
        white-space: nowrap;
      }

      .save-modal-section-count {
        display: flex;
        align-items: center;

        span {
          font-size: 12px;
          line-height: 14px;
          opacity: 0.5;
          margin-top: 3px;
        }

        img {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }
      }

      span {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        flex: 1;
      }
    }

    .selected-group {
      background: #fff4f6;
      border: 2px solid #fff4f6;
      margin-top: 24px;
      cursor: unset;

      &:hover {
        border: 2px solid #fff4f6;
        box-shadow: unset;
      }

      .selected-group-cancel-btn {
        width: 40px;
        height: 40px;
        background: white;
        border-radius: 12px;
        align-items: center;
        justify-content: center;
        display: flex;
        margin-right: -13px;
        cursor: pointer;

        &:hover {
          box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
        }
      }
    }

    .create-new-button {
      border: 2px solid #ececec;
      border-radius: 12px;
      display: flex;
      height: 48px;
      align-items: center;
      padding-left: 20px;
      padding-right: 20px;
      cursor: pointer;
      transition: 0.1s all;
      margin-top: 15px;
      margin-bottom: -20px;

      &:hover {
        border: 2px solid transparent;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
      }

      span {
        flex: 1;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        color: #a893f9;
      }
    }

    .group-emoji {
      width: 20px;
      height: 20px;
    }
  }

  .mobile {
    font-size: 14px !important;
  }

  .mobile-modal {
    padding-left: 0px !important;
    padding-right: 0px !important;

    .save-modal-lists {
      overflow: unset !important;
      overflow-x: unset !important;
      margin-left: unset !important;
      margin-right: unset !important;
      padding-left: unset !important;
      padding-right: unset !important;
      max-height: unset !important;
    }
  }

  * :global(.overlay-aligned-top) {
    align-items: flex-start !important;
    padding-top: calc(50vh - 320px);
  }

  * :global(.modal__container.show-info-steps) {
    min-width: 780px;
    max-width: 780px;
    min-height: 684px;
    max-height: 684px;

    padding-bottom: 0px;
    margin-bottom: 0px;
    background: linear-gradient(343.65deg, #eae4ff -0.74%, #ffffff 72.21%),
      linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
    border-radius: 20px;
  }

  :global(.mobile .modal__overlay .modal__container.show-info-steps) {
    min-width: inherit !important;
    max-width: inherit !important;
    min-height: inherit !important;
    max-height: inherit !important;
    padding: 0px !important;
    margin-top: 30px !important;
  }

  :global(.mobile .modal__overlay .modal__container.show-info-steps .modal__content) {
    margin-top: 0px;
    margin-bottom: 0px;
  }
</style>

<div class="svelte-modal">
  {#if showInfoStepsModal}
    <Modal
      on:close={displayGroupsModal}
      show={showInfoStepsModal}
      mobile={mobile}
      showCloseButton={false}
      closeOnOverlayClick={false}
      fadeInDuration={0}
      containerClass={'show-info-steps'}>
      <div slot="content" style="text-align: center;">
        <div>
          <AfterCreateInfo
            mobile={mobile}
            on:finished={(_e) => {
              groupModalFadeInDuration = 0;
              displayGroupsModal();
            }} />
        </div>
      </div>
    </Modal>
  {:else if showGroupsModal || showSectionsModal || showAddNewListModal}
    <Alert
      mobile={mobile}
      on:yes-click={() => {
        showCancelDialogForSectionClose = false;
        hideSectionsModal();
      }}
      question="Are you sure you want to exit without saving?"
      yesButtonText="Exit, without saving"
      cancelText="Back"
      objectText={null}
      bind:show={showCancelDialogForSectionClose} />

    <Modal
      style={mobile ? '' : 'width: 490px;'}
      mobile={mobile}
      overlayClass={mobile ? '' : 'overlay-aligned-top'}
      fadeInDuration={groupModalFadeInDuration}
      bind:show={showGroupsModal}>
      <div slot="content" class="save-modal" class:mobile-modal={mobile}>
        <div class="save-modal-header">
          {currentUser && ownerIds && ownerIds.includes(currentUser.id)
            ? 'Copy this item to another list'
            : 'Save this item to a list'}
        </div>

        {#if loadingGroups}
          <div style="text-align: center; opacity: 0.7; color: #1a1a1a; margin-top: 35px;">
            <i class="fa fa-spin fa-spinner" />
            <span style="margin-left: 8px;">Loading</span>
          </div>
        {:else}
          {#if searched || (groups && groups.length > 6)}
            <div class="search-search-bar">
              <i class="fa fa-search" style="position: absolute; z-index: 1; top: 17px; left: 17px; color: #A893F9;" />
              <Input
                bind:inputEl={groupSearchEl}
                style="height: 48px;"
                inputStyle="padding-left: 44px;"
                placeholder="Find a list"
                on:keyup={searchGroups}
                focus={!mobile} />
            </div>
          {/if}
          <div class="save-modal-lists purple-scrollbar" class:save-modal-lists-scrolled={!mobile && groups.length > 5}>
            <div class="save-modal-lists-label">Your lists</div>

            {#each groups as each_group}
              {#if each_group.id != group.id}
                <div class="save-modal-item" on:click|preventDefault|stopPropagation={() => selectGroup(each_group)}>
                  <img
                    class="group-emoji"
                    src={each_group && each_group.emoji && each_group.emoji.outside_src}
                    alt="{each_group && each_group.emoji && each_group.emoji.name} emoji" />
                  <span class="save-modal-item-name">{each_group.name}</span>
                </div>
              {/if}
            {/each}
          </div>
          <div
            class="create-new-button"
            on:click={() => {
              hideGroupsModal();
              displayAddNewListModal();
            }}>
            <span>Create new list</span>
            <img src="/images/save-button/plus.svg" />
          </div>
        {/if}
      </div>
    </Modal>

    <Modal
      style={mobile ? '' : 'width: 490px;'}
      mobile={mobile}
      hide={() => hideSectionsModal(true)}
      bind:show={showSectionsModal}>
      <div slot="content" class="save-modal" class:mobile-modal={mobile}>
        <div class="save-modal-header">Save this item to a list</div>
        <div class="save-modal-item selected-group">
          <img
            class="group-emoji"
            src={selectedGroup && selectedGroup.emoji && selectedGroup.emoji.outside_src}
            alt="{selectedGroup && selectedGroup.emoji && selectedGroup.emoji.name} emoji" />
          <span class="save-modal-item-name">{selectedGroup.name}</span>
          <div class="selected-group-cancel-btn" on:click={unselectGroup}>
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="20">
                <rect x="0.686523" y="10" width="14" height="14" transform="rotate(-45 0.686523 10)" fill="white" />
              </mask>
              <g mask="url(#mask0)">
                <path
                  d="M7.51592 5.05025C6.99687 4.5312 6.15532 4.5312 5.63627 5.05025C5.11722 5.5693 5.11722 6.41085 5.63627 6.9299L8.70637 10L5.63627 13.0701C5.11722 13.5891 5.11722 14.4307 5.63627 14.9497C6.15532 15.4688 6.99687 15.4688 7.51592 14.9497L10.586 11.8797L13.6561 14.9497C14.1752 15.4688 15.0167 15.4688 15.5358 14.9497C16.0548 14.4307 16.0548 13.5891 15.5358 13.0701L12.4657 10L15.5358 6.9299C16.0548 6.41085 16.0548 5.5693 15.5358 5.05025C15.0167 4.5312 14.1752 4.5312 13.6561 5.05025L10.586 8.12035L7.51592 5.05025Z"
                  fill="#FF5567" />
              </g>
            </svg>
          </div>
        </div>
        <div
          class="save-modal-lists purple-scrollbar"
          class:save-modal-lists-scrolled={!mobile && selectedGroup.sections.length > 5}>
          <div class="save-modal-lists-label">Choose a section:</div>

          {#each selectedGroup.sections as section (section)}
            <div class="save-modal-item" on:click|preventDefault|stopPropagation={() => selectSection(section)}>
              <span class="save-modal-item-name" style="margin-left: 0px;">{section.name}</span>
              <div class="save-modal-section-count">
                <img src="/images/save-button/star.png" />
                <span>{section.total}</span>
              </div>
            </div>
          {/each}
        </div>
        {#if showAddNewSection}
          <div class="add-new-section-container">
            <Input
              bind:inputEl={newSectionEl}
              focus={!mobile}
              placeholder="Name new section"
              on:enter={() => newSectionEl.blur()}
              on:blur={() => setTimeout(createNewSection, 200)} />
            <img
              on:click|preventDefault|stopPropagation={() => (newSectionEl.value = '')}
              src="/images/save-button/close.png" />
          </div>
        {:else}
          <div
            class="create-new-button"
            on:click={() => {
              displayAddNewSection();
            }}>
            <span>Create new section</span>
            <img src="/images/save-button/plus.svg" />
          </div>
        {/if}
      </div>
    </Modal>

    <Modal
      on:close={() => {
        displayGroupsModal();
      }}
      style={mobile ? '' : 'width: 490px;'}
      mobile={mobile}
      bind:show={showAddNewListModal}>
      <div slot="content" class="save-modal" class:mobile-modal={mobile}>
        <div class="save-modal-header">Save to a new list</div>
        <div class="save-modal-subheader">Name your list to save the item to it</div>
        <div style="margin-top: 40px; position: relative;">
          <img
            src="/emojis/purple_star.png"
            style="position: absolute; top: 14px; left: 20px; z-index: 1; width: 20px; height: 20px;" />
          <Input
            bind:inputEl={groupInputEl}
            placeholder="My new list"
            inputStyle="padding-left: 52px;"
            on:enter={createNewList}
            focus={!mobile} />
        </div>
        <div style="margin-top: 30px; width: 170px; margin-left: auto; margin-right: auto;">
          <Button loading={creatingGroup} text="Create and save" on:click={createNewList} />
        </div>
      </div>
    </Modal>
  {:else if showCreateAccountModal}
    <div>
      <CreateAccountModal
        msgStyle="font-size: 20px;"
        mobile={mobile}
        successCallback={(user) => {
          if (user.id && user.api_token && !user.is_new) {
            groupModalFadeInDuration = 0;
            displayGroupsModal();
            return;
          }
          logUserCreatedThroughSaveButton(user);
          showInfoStepsModal = true;
          showCreateAccountModal = false;
        }}
        beforeDataSend={(data) => {
          data['sign_up_source'] = {
            source: 'save',
            group_base_id: group && group.id,
            rec_object_id: recObject && recObject.id,
          };
          return data;
        }}
        showPassword={true}
        saveButtonFlow={true}
        buttonText="Create account"
        bind:showModal={showCreateAccountModal} />
    </div>
  {/if}
</div>

<button
  class:mobile={mobile}
  style={style}
  class="ui-save-it undraggable"
  class:ui-save-it-collapsed={collapsed}
  class:ui-save-it-hovered={hovered}
  on:click|preventDefault|stopPropagation={saveItButtonClicked}>
  {#if showPin}
    {#if SLOTS.pin}
      <slot name="pin" />
    {:else}
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14 0H6C4.8955 0 4 0.8955 4 2V10C4 11.1045 4.8955 12 6 12H14C15.1045 12 16 11.1045 16 10V2C16 0.8955 15.1045 0 14 0ZM3 10.5V4H2C0.8955 4 0 4.8955 0 6V14C0 15.1045 0.8955 16 2 16H10C11.1045 16 12 15.1045 12 14V13H5.5C4.3955 13 3 11.6045 3 10.5Z"
          fill="#AE94F9" />
      </svg>
    {/if}
  {/if}

  <span style="{collapsed ? 'display: none;' : ''} {showPin ? 'margin-left: 12px' : ''}">{text}</span>
</button>
